import { headerStyles } from "@insite/content-library/Widgets/MyLists/MyListsHeader";
import { color } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

headerStyles.container = {
    gap: 10,
    css: css`
        padding-bottom: 20px;
        border-bottom: 1px solid ${color("common.border")};
        margin-bottom: 25px;
    `,
};
headerStyles.leftBottomGridItem = {
    width: [12, 6, 2, 2, 2],
};
headerStyles.rightBottomGridItem = {
    width: [12, 6, 2, 2, 2],
};
